import { XIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'

import * as S from './badge.styled'
import { BadgeProps } from './badge.types'

export const Badge = ({
  children,
  color = 'neutral',
  icon,
  size = 'medium',
  variant = 'solid',
  onRemove,
  removeIconSize = '1.4rem',
  ...rest
}: BadgeProps) => {
  return (
    <S.Badge {...rest} $color={color} $size={size} $variant={variant} data-component-id="Badge">
      {icon && <Icon icon={icon} size="1.3em" />}
      {children}
      {onRemove && (
        <S.RemoveButton
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
        >
          <Icon icon={XIcon} size={removeIconSize} />
        </S.RemoveButton>
      )}
    </S.Badge>
  )
}
